import { Circle } from 'styled-spinkit';
import PropTypes from 'prop-types';

const CircleLoader = ({ size, color, className }) => {
    return <Circle size={size || '18'} color={color || 'var(--greyExtraDarkColor)'} className={className} />;
};
CircleLoader.propTypes = {
    size: PropTypes.string,
    color: PropTypes.string
};

export default CircleLoader;
